export default function ProgressBar({ value }) {
  return (
    <div className="is-flex is-justify-content-center">
      <progress className="progress is-medium is-info" max="100" value={value} style={{ width: "50%"}}>
        Đang Cập Nhật
      </progress>
    </div>
  )
}
